module.exports = __webpack_public_path__ + "media/images/favicon-22f4a9ec60638ab4d36bafd48e770f0d.ico";